export default __webpack_public_path__ + "static/media/icon_1.90c785d3.svg";